'use client';

import * as React from 'react';
import { PropertyCardImage } from './PropertyCard.carousel.tsx';
import { PropertyCardDetails } from './PropertyCard.details.tsx';
import type { PropertyCardPriceDisplayFields, PropertyCardProps } from '@federa/types/ui-property-card';

interface CardContentProps {
	property: PropertyCardProps['property'];
	sentinelImageSrc?: string;
	eagerImage: boolean;
	state: {
		currentImageIndex: number;
		handlePreviousImage: (e: React.MouseEvent) => void;
		handleNextImage: (e: React.MouseEvent) => void;
		handleSaveClick: (e: React.MouseEvent) => void;
		handleShareClick: (e: React.MouseEvent) => void;
		saveHovered: boolean;
		setSaveHovered: (v: boolean) => void;
		shareHovered: boolean;
		setShareHovered: (v: boolean) => void;
	};
	actions: {
		onSave: PropertyCardProps['onSave'];
		onShare: PropertyCardProps['onShare'];
		isSaved: boolean;
	};
	/** Forwarded VERBATIM to `PropertyCardDetails`, so it binds that component's own shape rather than restating it. */
	display: PropertyCardPriceDisplayFields;
}

export function CardContent({ property, sentinelImageSrc, eagerImage, state, actions, display }: CardContentProps) {
	return (
		<>
			<PropertyCardImage
				images={property.images}
				sentinelImageSrc={sentinelImageSrc}
				eagerImage={eagerImage}
				currentImageIndex={state.currentImageIndex}
				onPrevious={state.handlePreviousImage}
				onNext={state.handleNextImage}
			/>
			<PropertyCardDetails
				property={property}
				onSave={actions.onSave}
				onShare={actions.onShare}
				isSaved={actions.isSaved}
				priceLabel={display.priceLabel}
				priceAmount={display.priceAmount}
				showCountdown={display.showCountdown}
				countdownLabel={display.countdownLabel}
				countdownColor={display.countdownColor}
				handleSaveClick={state.handleSaveClick}
				handleShareClick={state.handleShareClick}
				saveHover={{
					hovered: state.saveHovered,
					setHovered: state.setSaveHovered,
				}}
				shareHover={{
					hovered: state.shareHovered,
					setHovered: state.setShareHovered,
				}}
			/>
		</>
	);
}
